<template>
  <div style="display: inline-block" @click.stop="$emit('click', $event)" class="article-caption">
    <div>
      <span class="body-2 heavy articleId" v-html="highlightedArticleId(articleNo)"></span>
      <v-tooltip right v-if="collective">
        <template v-slot:activator="{ on, attrs }">
          <span class="icon-gemeinschaftsartikel" v-on="on" v-bind="attrs"></span>
        </template>
        <span class="caption">
          {{ $t('sl.collectiveArticles.collectiveArticle') }}
        </span>
      </v-tooltip>

      <span @click.stop class="article-message-indicator">
          <ArticleMessageIndicator  :article="article"></ArticleMessageIndicator>
      </span>
    </div>
    <div class="articleName" v-html="highlightedArticleName(article.name)">
    </div>
  </div>
</template>

<script>

import ArticleMessageIndicator from "@/components/SmartLogistics/Article/ArticleMessageIndicator.vue";
import {inlineSearchMixin} from "../../../mixins/SmartLogistics/inlineSearchMixin";

export default {
  name: 'ArticleCaption',
  components: {ArticleMessageIndicator},
  mixins: [inlineSearchMixin],
  props: {
    article: {
      type: Object,
      required: true,
    },
    collective: {
      type: Boolean,
      default: false
    },
  },

  emits: ['clicked'],

  computed:{
    articleNo(){

      if(this.article.ownArticleNo){
        return this.article.ownArticleNo
      }

      if(this.article.internalID){
        return this.article.internalID
      }

      if(this.article.artikelNrLAG){
        return this.article.artikelNrLAG
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/settings/color";
.article-caption {
  .articleId, .articleName {
    transition: color 0.2s ease-in-out;
  }
  &:hover {
    .articleId, .articleName {
      color: $color-primary;
    }
  }
}
.article-message-indicator {
  cursor: default !important;
}
.icon-gemeinschaftsartikel {
  font-size: 18px;
  margin-left: 10px;
}
</style>
